import Swiper from 'swiper';
import SwiperCore, { Autoplay } from 'swiper/core';

export default () => {
    const sliderContainer = document.querySelector('.brandSwiper');
    if (sliderContainer) {
        SwiperCore.use([Autoplay]);
        new Swiper(sliderContainer, {
            // loop: true,
            allowTouchMove: true,
            // speed: 1500,
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            speed: 10000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });
    }
};
